import * as ng from 'angular';
import { UISelectService } from '../../../../services/ui-select.service';
import { ArchiSmallServices } from '../../../../services/archismall.service';
import { appContext } from '../../../../app.context';

class ConservazioneCaricaDocumentoAltroDocumentoStep2Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices',
        '$sce',
        '$filter',
        'UiSelectService'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices,
        private $sce: ng.ISCEService,
        private $filter: ng.IFilterService,
        private _UISelectService: UISelectService
    ) {
        _UISelectService = new UISelectService();
        $scope.pageHeader = 'Carica Documento';
        $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

        if (store.get('conservazioneClasseDocumentale') === null) {
            $state.go('home.conservazione-carica-documento-step1');
            return;
        }

        $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

        $scope.years = [];
        const curr_year = new Date().getFullYear();
        for (let i = curr_year - 1; i <= curr_year; i++) {
            $scope.years.push(i);
        }
        const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {anno: number, scadenza: string}[];
        if (years) {
          for (let year of years) {
            if (new Date(year.scadenza) > new Date()) {
              $scope.years.push(year.anno);
            }
          }
        }


        $scope.destinatario = {};
        $scope.produttore = {};
        $scope.seiProduttore = 'Si';
        $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
        $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
        let isDestinatarioCFDisabled, isProduttoreCFDisabled, isDestinatarioPIVADisabled, isProduttorePIVADisabled;

        $scope.prev = () => {
            $scope.setConservazioneSettings();
            $state.go('home.conservazione-carica-documento-step1', { 'classeDocumentale': $scope.classeDocumentale });
        };

        // <editor-fold desc='openWorkerModal'>
        $scope.openWorkerModal = (size) => {
            if (
              $scope.anagraficaProduttoreIsNew ||
              $scope.anagraficaDestinatarioIsNew
            ) {
              $scope.saveAnagrafica();
            }

            $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

            $scope.settings.denominazioneDestinatario =
              $scope.destinatario.anagrafica.full_name;

            $scope.settings.denominazioneProduttore =
              $scope.produttore.anagrafica.full_name;

            $scope.settings.periodoEsercizio =
              $scope.settings.annoFiscaleAl;


            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'workerAltriDocumentiVersamentoModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    settings: $scope.settings
                }
            });
        };
        // </editor-fold>

        $scope.saveAnagrafica = () => {

            let anagrafica = [];

            if ($scope.anagraficaProduttoreIsNew) {
              anagrafica.push({
                email_pec: "",
                emails: [],
                company_name: $scope.produttore.anagrafica.full_name,
                piva: $scope.settings.produttorePIVA,
                fiscal_code: $scope.settings.produttoreCF,
              });
            }

            if ($scope.anagraficaDestinatarioIsNew) {
              anagrafica.push({
                email_pec: "",
                emails: [],
                company_name: $scope.destinatario.anagrafica.full_name,
                piva: $scope.settings.destinatarioPIVA,
                fiscal_code: $scope.settings.destinatarioCF,
              });
            }


            anagrafica.forEach(element => {
                ArchiSmallServices.insertAnagrafica(element).then(
                  (response) => {
                    // ??
                  },
                  (error) => {
                    if (
                      error.errorCode !==
                      $rootScope.ArchiSmallERRORS.DUPLICATE_KEY
                    ) {
                      $rootScope.alert("error", error);
                    }
                  }
                );
            });
        };

        $rootScope.formsubmitted = false;

        // <editor-fold desc='setConservazioneSettings'>
        $scope.setConservazioneSettings = () => {

            $scope.settings.denominazioneDestinatario =
              $scope.destinatario.anagrafica;

            $scope.settings.denominazioneProduttore =
              $scope.produttore.anagrafica;

            $scope.classeDocumentale = $scope.settings.classeDocumentale.key;

            let userSettings = {
                'key': $scope.classeDocumentale,
                'value': $scope.settings
            };

            ArchiSmallServices.setConservazioneSettings(userSettings)
                .then((response) => {
                    // ?
                }, (error) => {
                    $rootScope.alert('error', error);

                });
        };
        // </editor-fold>

        // <editor-fold desc='getConservazioneSettings'>
        $scope.getConservazioneSettings = () => {
            $rootScope.readyToUse = false;
            $scope.currentClasseDocumentale = $scope.classeDocumentale;
            ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
                .then((response: any) => {
                    if (response !== undefined && response !== '') {
                        $scope.settings = response.value;
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

                        if ($scope.settings.denominazioneDestinatario !== undefined) {
                            $scope.destinatario.anagrafica = $scope.settings.denominazioneDestinatario;
                            isDestinatarioCFDisabled = $scope.settings.destinatarioCF !== '' && $scope.settings.destinatarioCF !== undefined;
                            isDestinatarioPIVADisabled = $scope.settings.destinatarioPIVA !== '' && $scope.settings.destinatarioPIVA !== undefined;
                            $scope.seiProduttore = 'Si';
                        }
                        if ($scope.settings.denominazioneProduttore !== undefined) {
                            $scope.produttore.anagrafica = $scope.settings.denominazioneProduttore;
                            isProduttoreCFDisabled = $scope.settings.produttoreCF !== '' && $scope.settings.produttoreCF !== undefined;
                            isProduttorePIVADisabled = $scope.settings.produttorePIVA !== '' && $scope.settings.produttorePIVA !== undefined;
                            $scope.seiProduttore = 'No';
                        }
                    } else {
                        $scope.settings = $scope.getSettingsDefault();
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
                        $scope.filesIndex = $scope.settings.files.length;
                        $rootScope.filesUploadedNumber = $scope.filesIndex;
                    }
                    $rootScope.readyToUse = true;
                }, (error) => {
                    $rootScope.alert('error', error);

                });
        };
        // </editor-fold>

        if ($scope.classeDocumentale !== '') {
            $scope.getConservazioneSettings();
            // $state.go('home.conservazione-carica-documento-' + $scope.classeDocumentale + '-step2');
        }

        $scope.dpOpened = {
            dataDocumento: false,
        };
        $scope.openDP = ($event, opened) => {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.dpOpened[opened] = true;
        };
        /* tslint:disable:no-string-literal */
        $scope.autoOpen = ($event, opened) => {
            if (appContext.userBrowser['isIE']) {
                return;
            }
            $event.preventDefault();
            $event.stopPropagation();
            $scope.dpOpened[opened] = true;
        };
        /* tslint:enable:no-string-literal */
        $scope.trustAsHtml = (value) => {
            return $sce.trustAsHtml(value);
        };
        $scope.getAnagraficaTypeaheadValues = () => {
            ArchiSmallServices.getAnagraficaTypeaheadValues()
                .then((response) => {
                    $scope.anagrafica = response;
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        $scope.getAnagraficaTypeaheadValues();

        $scope.autocompleteFields = (item, produttore) => {
            if (item !== undefined && typeof item === 'object') {
                if (!produttore) {

                    $scope.settings.destinatarioPIVA = item.piva;
                    $scope.settings.destinatarioCF = item.fiscal_code;
                    $scope.anagraficaDestinatarioIsNew = item.piva == null;

                    isDestinatarioCFDisabled =
                        item.fiscal_code !== "" && item.fiscal_code !== undefined;
                    isDestinatarioPIVADisabled =
                        item.piva !== "" && item.piva !== undefined;

                } else {
                    $scope.settings.produttorePIVA = item.piva;
                    $scope.settings.produttoreCF = item.fiscal_code;
                    $scope.anagraficaProduttoreIsNew = item.piva == null;

                    isProduttoreCFDisabled =
                      item.fiscal_code !== "" && item.fiscal_code !== undefined;
                    isProduttorePIVADisabled =
                      item.piva !== "" && item.piva !== undefined;
                }
            }
        };


        $scope.clear = ($event, $select) => {
            _UISelectService.clear($event, $select);

            $scope.settings.destinatarioPIVA = '';
            $scope.settings.destinatarioCF = '';
            $scope.destinatario.anagrafica = '';
            isDestinatarioCFDisabled = false;
            isDestinatarioPIVADisabled = false;
            $scope.settings.produttorePIVA = '';
            $scope.settings.produttoreCF = '';
            $scope.produttore.anagrafica = '';
            isProduttoreCFDisabled = false;
            isProduttorePIVADisabled = false;

            $scope.anagraficaProduttoreIsNew = false;
            $scope.anagraficaMittenteIsNew = false;
        };

        $scope.refreshResults = ($select) => {
            _UISelectService.refreshResults($select);
        };

        $scope.isDestinatarioCFDisabled = () => {
            return isDestinatarioCFDisabled;
        };

        $scope.isDestinatarioPIVADisabled = () => {
            return isDestinatarioPIVADisabled;
        };

        $scope.isProduttoreCFDisabled = () => {
            return isProduttoreCFDisabled;
        };

        $scope.isProduttorePIVADisabled = () => {
            return isProduttorePIVADisabled;
        };
    }

}

export const ConservazioneCaricaDocumentoAltroDocumentoStep2Component: ng.IComponentOptions = {
    template: require('./conservazione-carica-documento-altro-documento-step2.html'),
    controller: ConservazioneCaricaDocumentoAltroDocumentoStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-altro-documento-step2/conservazione-carica-documento-altro-documento-step2.ts